<template>
  <router-view />
</template>

<script>
export default {
  name: 'Container'
}
</script>

<style lang='less' scoped>

</style>
